import Vue from "vue";
import Vuex from "vuex";
import { createVuexStore } from "@/types";
import { AppStore } from "@/store/store";
Vue.use(Vuex);
export const instance = new AppStore();
export default createVuexStore(instance, {
    strict: true,
});
